import NumberPicker from './number-picker';
import './styles/index.scss';
export default NumberPicker;
